import { Component, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectConfiguration, selectIsGisTokenRegistered } from '../../authentication/store/user.selector';
import { Configuration } from '../../authentication/model/configuration.model';
import { FabService } from '../../shared/service/fab.service';
import { FilterComponent } from '../filter/filter.component';
import { WebMapComponent } from '../../map/components/web-map.component';
import { BuildingListGroupComponent } from '../building-list-group/building-list-group.component';
import { DetailedListComponent } from '../detailed-list/detailed-list.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'sibat-buildings',
  template: `
    <sibat-filter></sibat-filter>
    <section>
      <sibat-web-map
        [configuration]="configuration$ | async"
        [registeredGisToken]="gisTokenIsRegistered$ | async"
        [centeredOnBuildings]="centeredOnBuildings"
        (selectionChange)="showSelectedBuildingsTab()"
      ></sibat-web-map>
      <span class="separator"></span>
      <sibat-lists
        [detailedSelectionDisplay]="displayDetailedSelection"
        (centerOnBuildings)="centerOnSelectedBuildings($event)"
        (showDetailedSelection)="showDetailedSelection(true)"
        [(selectedTab)]="selectedBuildingListTab"
      ></sibat-lists>
      @if (displayDetailedSelection) {
      <sibat-detailed-list (hide)="showDetailedSelection(false)"></sibat-detailed-list>
      }
    </section>
  `,
  styleUrls: ['./buildings.component.scss'],
  imports: [FilterComponent, WebMapComponent, BuildingListGroupComponent, DetailedListComponent, AsyncPipe],
})
export class BuildingsComponent implements OnDestroy {
  configuration$: Observable<Configuration | undefined> = this.store.select(selectConfiguration);
  gisTokenIsRegistered$: Observable<boolean> = this.store.select(selectIsGisTokenRegistered);
  centeredOnBuildings: number[] = [];
  displayDetailedSelection = false;
  selectedBuildingListTab = 0;

  constructor(private store: Store, private fabService: FabService) {}

  ngOnDestroy(): void {
    this.fabService.clearFabOptions();
  }

  centerOnSelectedBuildings(buildingIds: number[]) {
    this.centeredOnBuildings = buildingIds;
  }

  showDetailedSelection(displayDetailedSelection: boolean) {
    this.displayDetailedSelection = displayDetailedSelection;
  }

  showSelectedBuildingsTab = () => {
    this.selectedBuildingListTab = 1;
  };
}
